export function mapUIVariantsToApi(productVariants) {
  if (!Array.isArray(productVariants)) return [];

  let sortOrder = 0;

  return productVariants.flatMap((variant) =>
    (variant.options || [])
      .filter((group) => Array.isArray(group.options) && group.options.length)
      .map((group) => ({
        ...group,
        status: true,
        name: group.name, // Colors, Sizes
        options: group.options.join("|"), // ✅ "Red|Green|Blue"
        optionImages: Array.isArray(group.optionImages)
          ? group.optionImages.filter((img) => img && img.trim()).join("|")
          : "",
        sortOrder: sortOrder++,
      })),
  );
}

// export function mapApiVariantsToUI(apiVariants) {
//     if (!Array.isArray(apiVariants) || apiVariants.length === 0) return [];

//     return [
//         {
//             name: "Variant One", // or apiVariants[0]?.variantName if exists
//             sortOrder: 0,
//             status: true,

//             options: apiVariants.map((v) => ({
//                 name: v.name,

//                 options: v.options
//                     ? v.options.split("|").map(o => o.trim()).filter(Boolean)
//                     : [],

//                 allOptions: v.options
//                     ? v.options.split("|").filter(Boolean)
//                     : [],

//                 optionImages: v.optionImages
//                     ? v.optionImages.split("|").filter(Boolean)
//                     : [],

//                 optionImagesPreview: v.optionImages
//                     ? v.optionImages.split("|").filter(Boolean)
//                     : []
//             }))
//         }
//     ];
// }

export function mapApiVariantsToUI(apiVariants) {
  if (!Array.isArray(apiVariants)) return {};

  return apiVariants.reduce((acc, v) => {
    acc[v.name] = v.options
      ? v.options
          .split("|")
          .map((o) => o.trim())
          .filter(Boolean)
      : [];
    return acc;
  }, {});
}
